<div
  [ngClass]="{
    'w-10 h-10': size === IconSize.LARGE,
    'w-6 h-6': size === IconSize.DEFAULT,
    'w-[20px] h-[20px]': size === IconSize.SMALL,
    'w-4 h-4': size === IconSize.MINI,
    'w-[12px] h-[12px]': size === IconSize.XSMALL,
  }"
  [ngStyle]="{ color: color }"
  [innerHTML]="iconSvg"
></div>
